module.exports = __webpack_public_path__ + "media/images/story/typo/declarationMode-d89dbd775626dc02c571ed8df6d97509.svg";